module.exports = __webpack_public_path__ + "img/xrp.639b151a.svg";